import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { BottomSheet } from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css';
import uuid from 'uuid-random';
import { ModalBase } from '@panel/commons';
import SectionLayout from '../SectionLayout';
import { ReputationSelectors } from '../../ducks/reputation';
import { dataRatingsAdapter } from '../dataRatingsAdapter';
import EmptyStateScore from '../EmptyStateScore';
import { Modal } from '../Modals/ModalWrapper';
import Comment from '../Comment';
import {
  Container,
  TitleText,
  MainArea,
  LeftSide,
  ContainerRaitings,
  RightSide,
  ContainerValue,
  BottomSheetContainer,
  BottomSheetTitle,
  ModalContainer,
  CommentsContainer,
  HeaderSectionContainer,
  MobileBajadaContainer,
  TitleContainer
} from './styles';
import './buttonSheetStyles.css';

const PublisherPermanencieSection = ({ device, reloadDispatch, permanence, error }) => {
  const { t } = useTranslation();
  const isMobile = device === 'mobile';
  const [ratingsData, setRatingsData] = useState({});
  const [, setProgressBarData] = useState([]);
  const [openBottomSheet, setOpenBottomSheet] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const { ratings, customersComments } = useSelector(ReputationSelectors.getReputationState);

  const { generalScore, responseTime, postingContent, attention, recommendYou, notRespondedCount } = ratingsData;

  useEffect(() => {
    if (ratings) setRatingsData(dataRatingsAdapter(ratings));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ratings]);

  useEffect(() => {
    setProgressBarData([
      { value: postingContent },
      { value: responseTime },
      { value: attention },
      { value: recommendYou }
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ratingsData]);

  const getTopEmptyState = () => {
    if (device === 'mobile') return '20px';
    if (device === 'desktop') return '0px';
    return '30px';
  };

  function formatPermanence(months) {
    if (months == null) {
      return '';
    }

    if (months > 24) {
      return t('panel.reputacion.permanence.date.anios.over');
    }

    if (months > 12) {
      const anios = Math.floor(months / 12);

      if (anios === 1) {
        return t('panel.reputacion.permanence.date.anios.single', { anios });
      }

      return t('panel.reputacion.permanence.date.anios', { anios });
    }

    if (months === 1) {
      return t('panel.reputacion.permanence.date.meses.single', { meses: months });
    }

    return t('panel.reputacion.permanence.date.meses', { meses: months });
  }

  return (
    <SectionLayout
      data-panel='panel-estadisticas-ratings'
      marginTop='0px'
      paddingBottom={notRespondedCount ? '24' : null}
    >
      {device === 'desktop' && (
        <Container>
          {!error ? (
            <MainArea device={device} notRespondedCount={notRespondedCount}>
              <LeftSide device={device} data-panel='ratings-container-leftSide'>
                <div
                  style={{
                    fontFamily: 'Hind',
                    fontWeight: 600,
                    fontSize: '20px',
                    lineHeight: '26px'
                  }}
                >
                  {t('panel.reputacion.permanence.title')}
                </div>
                {permanence.months && permanence.months > 3 ? (
                  <div
                    style={{
                      fontFamily: 'Hind',
                      fontWeight: 400,
                      fontSize: '14px',
                      lineHeight: '22.41px'
                    }}
                  >
                    <p>{t('panel.reputacion.permanence.bajada.nodata')}</p>
                  </div>
                ) : (
                  <div
                    style={{
                      fontFamily: 'Hind',
                      fontWeight: 400,
                      fontSize: '14px',
                      lineHeight: '22.41px'
                    }}
                  >
                    <p>{t('panel.reputacion.permanence.date.nodata.visible')}</p>
                  </div>
                )}
              </LeftSide>
              <RightSide device={device} data-panel='ratings-container-rightSide'>
                {permanence.months && permanence.months > 3 && (
                  <ContainerRaitings device={device} generalScore={generalScore}>
                    <ContainerValue device={device} data-panel='ratings-value'>
                      {formatPermanence(permanence.months)}
                    </ContainerValue>
                  </ContainerRaitings>
                )}
              </RightSide>
              {showModal && !isMobile && (
                <Modal>
                  <ModalBase
                    openModal={showModal}
                    onClose={() => setShowModal(false)}
                    width='588px'
                    height='562px'
                    rightPosition='25px'
                    topPosition='25px'
                  >
                    <ModalContainer>
                      <TitleText data-panel='ratings-moreComments-modal-title' mBottom='32px' fontSize='20px'>
                        {t('panel.estadisticas.ratings.moreComments.title')}
                      </TitleText>
                      <CommentsContainer data-panel='ratings-moreComments-modal-container'>
                        {customersComments &&
                          customersComments.map(customerComment => (
                            <Comment key={uuid()} customerComment={customerComment} keyId={uuid()} />
                          ))}
                      </CommentsContainer>
                      {/* <MoreComments onClick={() => setShowModal(false)}>
                    Ver menos comentarios <ChevronDown src={ChevronDownIcon} alt='down' />
                  </MoreComments> */}
                    </ModalContainer>
                  </ModalBase>
                </Modal>
              )}
              {isMobile && (
                <BottomSheet
                  open={openBottomSheet}
                  onDismiss={() => setOpenBottomSheet(false)}
                  snapPoints={({ maxHeight }) => [maxHeight / 1.12]}
                  header={React.createElement(
                    'div',
                    {},
                    <BottomSheetTitle data-panel='ratings-bottomSheet-title'>
                      {t('panel.estadisticas.ratings.moreComments.title')}
                    </BottomSheetTitle>
                  )}
                >
                  <BottomSheetContainer>
                    <CommentsContainer height='429px' data-panel='ratings-bottomSheet-container'>
                      {customersComments &&
                        customersComments.map(customerComment => (
                          <Comment key={uuid()} customerComment={customerComment} keyId={uuid()} />
                        ))}
                    </CommentsContainer>
                  </BottomSheetContainer>
                </BottomSheet>
              )}
            </MainArea>
          ) : (
            <EmptyStateScore
              withSpacing={device === 'desktop'}
              height={isMobile ? '160px' : '115px'}
              top={getTopEmptyState()}
              callback={reloadDispatch}
              text={t('panel.reputacion.permanence.title')}
            />
          )}
        </Container>
      )}

      {!error && device !== 'desktop' && (
        <Container>
          <HeaderSectionContainer>
            <TitleContainer>{t('panel.reputacion.permanence.title')}</TitleContainer>
          </HeaderSectionContainer>
          <MobileBajadaContainer>
            {permanence.months && permanence.months > 3 ? (
              <>
                <p>{t('panel.reputacion.permanence.bajada.nodata')}</p>
              </>
            ) : (
              <p>{t('panel.reputacion.permanence.date.nodata.visible')}</p>
            )}
          </MobileBajadaContainer>

          <MobileBajadaContainer>
            <ContainerValue device={device} data-panel='ratings-value'>
              {formatPermanence(permanence.months)}
            </ContainerValue>
          </MobileBajadaContainer>
        </Container>
      )}

      {error && device !== 'desktop' && (
        <EmptyStateScore
          withSpacing={device === 'desktop'}
          height={isMobile ? '160px' : '115px'}
          callback={reloadDispatch}
          text={t('panel.reputacion.permanence.title')}
        />
      )}
    </SectionLayout>
  );
};

export default PublisherPermanencieSection;
